import { Block } from '../Layout/Block'
import { styled, css } from '$utils/theme'
import { rem } from 'polished'

interface Props {
  options: string[]
  mini?: boolean
}

export const StyledBlock = styled(Block).attrs({})<Props>`
  border: solid 1px ${p => p.theme.colors.grey};
  border-radius: 25px;
  padding: ${p => rem(p.theme.sizes.tiny)} ${p => rem(p.theme.sizes.mini)};
  min-height: ${p => rem(p.theme.sizes.small)};
  bottom: 1px;
  &:not(:last-child) {
    ${p =>
      p.options.length > 1 &&
      css`
        margin-right: ${rem(p.theme.sizes.base)};
      `} ${p =>
      p.options.length > 1 &&
      p.mini &&
      css`
        margin-right: ${rem(p.theme.sizes.tiny)};
      `};
  }
  ${p =>
    p.mini &&
    css`
      border-radius: 5px;
      padding: 2px 7px 1px;
    `};
`



// WEBPACK FOOTER //
// ./src/views/components/BorderedText/BorderedText.styles.ts